var React = require('react');

function GreenDot (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"fill":"#376268","fillRule":"nonzero"},React.createElement("path",{"d":"M747.776 822.12c2.597-.446 4.922.298 7.572 1.788 2.603 1.463 3.64 3.089 5.403 5.42 1.556 2.058 1.24 4.812 1.188 7.22-.06 2.801-2.462 5.473-3.952 7.647-2.09 3.05-4.132 5.405-8.127 4.682-2.807-.508-7.73-1.928-9.333-4.425-1.177-1.834-2.64-4.256-3.206-6.34-1.228-4.522 1.249-9.092 4.267-12.261 1.764-1.851 3.605-3.287 6.188-3.731z","transform":"translate(-737 -822)"}))));
}

GreenDot.defaultProps = {"width":"25","height":"27","viewBox":"0 0 25 27"};

module.exports = GreenDot;

GreenDot.default = GreenDot;
